import CouponsEntity from '../coupons/coupons'
import CustomersEntity from '../customers/customers'
import { Entities } from '../entities'
import FilesEntity from '../files/files'
import { Paymethods } from '../paymethods'
import { ReferenceType, ValueType } from '../products/attributes'
import { NameAttributes } from '../products/name-attributes'
import { ProductCategoryEntity } from '../products/products'

export enum OrderStatus {
	new = 'new',
	pending = 'pending',
	processing = 'processing',
	on_the_way = 'on_the_way',
	rejected = 'rejected',
	delivered = 'delivered',
	refunded = 'refunded',
}

export enum WompiStatus {
	APPROVED = 'APPROVED',
	DECLINED = 'DECLINED',
	VOIDED = 'VOIDED',
	ERROR = 'ERROR',
	PENDING = 'PENDING',
}

export enum OrderPaymethods {
	card = 'card',
	pse = 'pse',
	nequi = 'nequi',
	cash = 'cash',
	bancolombia_transfer = 'bancolombia_transfer',
	daviplata = 'daviplata',
	payment_on_delivery = 'payment_on_delivery',
	none = 'none',
}

export enum ShippingType {
	payed = 'payed',
	payment_on_delivery = 'payment_on_delivery',
}

export default interface OrdersEntity {
	_id: string
	code: string
	customer: Partial<CustomersEntity>
	coupon: Partial<CouponsEntity>
	bill: OrderFileEntity
	status: OrderStatus
	payment_info: PaymentInfoEntity
	refunded?: OrderRefunded
	shipping_info: ShippingInfo
	products: OrderProductsEntity[]
	denial?: OrderDenialEntity
	_created?: string
	_modified?: string
	_deleted?: boolean
}

interface OrderRefunded {
	reason: string
}

export interface OrderDenialEntity {
	reason: string
}

interface OrderFileEntity {
	_id: string
	url: string
}

export interface PaymentInfoEntity {
	paymethod: OrderPaymethods
	status: WompiStatus
	transaction_id: string | null
	amount: string | null
	currency: string
	timestamp: string | null
	extra: PaymentInfoEntityExtra
}

interface PaymentInfoEntityExtra {
	brand: string | null
	last_four: string | null
	bank: string | null
}

export interface ShippingInfo {
	company: string | null
	company_address: string | null
	code: string | null
	date: string | null
	estimated_date: number | null
	evidenced: OrderFileEntity
	type: ShippingType | null
	price: number | null
}

interface OrderFileEntity {
	_id: string
	url: string
}

export interface OrderDenialEntity {
	reason: string
}

export interface OrderProductsEntity {
	_id?: string
	type: Entities
	category: ProductCategoryEntity
	shipping_info: ShippingInfoProductsOrder
	name: string
	description: string
	discount: number
	brand: string

	totalQuantity: number
	subtotal: number
	totalDiscount: number
	totalShipping: number
	total: number

	productDiscount: number
	couponDiscount: number

	attributes?: OrderAttributeProductsEntity[]
	_created?: string
}

export interface OrderAttributeProductsEntity {
	_id?: string
	name: NameAttributes[]
	type: Entities
	value: ValueType[]
	reference: ReferenceType[]
	quantity: number

	price: number
	subtotal: number
	productDiscount: number
	couponDiscount: number
	discount: number
	total: number

	image?: FilesEntity
	_created?: string
}

export interface ShippingInfoProductsOrder {
	isHaveShipping: boolean
	type: Paymethods
	price: number
}
